<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12">
          <h2>Associate an existing DOI to this dataset</h2>
        </v-col>
        <v-row>
          <v-col cols="12" sm="8">
            <v-form v-model="formIsValid">
              <v-text-field
                :rules="rules"
                outlined
                v-model="doi"
                placeholder="Write here the DOI of the resource"
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col cols="12" sm="4" class="text-left">
            <v-btn
              x-large
              color="warning"
              :disabled="!formIsValid"
              @click="autocompleteDOI()"
              ><v-icon left>mdi-link-variant-plus</v-icon> Associate DOI</v-btn
            >
          </v-col>
        </v-row>
      </v-row>
    </v-container>

    <!-- CONFIRM DIALOG -->
    <v-dialog
      v-model="dialog"
      v-if="dialog"
      max-width="800px"
      scrollable
      @click:outside="closeDialog"
    >
      <v-card height="600px">
        <v-card-title> Confirm DOI association </v-card-title>
        <v-card-text>
          <v-banner color="warning" dark elevation="2" single-line
            ><v-icon slot="icon" dark size="30">
              mdi-alert-octagon-outline
            </v-icon>
            Check DOI information before associating the DOI to the resource.
            The operation cannot be undone.</v-banner
          >
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right"><strong>DOI</strong></p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <p>{{ doiState.identifier.id }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right"><strong>URL</strong></p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <p>{{ doiState.identifier.url }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right"><strong>Title</strong></p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <p>{{ doiState.title }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right"><strong>Creator(s)</strong></p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <ul>
                  <li v-for="creator in doiState.author" :key="creator.name">
                    <p>
                      {{ creator.name }}
                    </p>
                  </li>
                </ul>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right"><strong>Publisher</strong></p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <p>{{ doiState.publisher }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" lg="3">
                <p style="text-align: right">
                  <strong>Publication Year</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="8" lg="9">
                <p>{{ doiState.year }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" dark @click="closeDialog">Cancel</v-btn>
          <v-btn @click="associateDOI()">Associate DOI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
var urljoin = require("url-join");
const HOST_ROOT = process.env.VUE_APP_ROOT_API;
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formIsValid: false,
      doi: null,
      dataset: null,
      dialog: false,
      doiState: {},
      rules: [(v) => !!v || "Please enter a valid DOI"],
    };
  },
  computed: {
    ...mapGetters("auth", ["getToken"]),
  },
  methods: {
    ...mapActions("auth", ["setIsLoading", "setLoadingMessage"]),
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },
    async associateDOI() {
      try {
        const headers = {
          Authorization: "Token " + this.getToken,
        };

        await axios.post(
          urljoin(
            HOST_ROOT,

            this.$route.params.fossilormodern === "fossil"
              ? "api/fossil-doi/"
              : "api/modern-doi/"
          ),
          {
            uuid: this.$route.params.uuid,
            doi: this.doi.trim(),
            is_internal: false,
          },
          {
            headers: headers,
          }
        );

        this.closeDialog();
        this.$router.go(-1);
      } catch (error) {
        alert(error);
        this.closeDialog();
        return;
      }
    },
    async autocompleteDOI() {
      var url = "https://doi.org/" + this.doi;
      try {
        this.setLoadingMessage("Loading DOI information. Please wait...");
        this.setIsLoading(true);
        const response = await axios.get(url, {
          headers: { Accept: "application/x-bibtex" },
        });
        /* alert(JSON.stringify(response.data)); */
        const dataa = response.data;
        var varlist = dataa.slice(1, -2).split(",\n").slice(1);
        var dictlist = varlist.map((x) => {
          var items = x.split("=");
          var key = items[0].trim();
          var value = items[1].trim().split(/\{|\}/).join("");
          value =
            key === "author"
              ? value.split(" and ").map((a) => {
                  return { name: a.trim() };
                })
              : value;
          key = key === "doi" ? "id" : key;
          return { [key]: value };
        });
        var dict = Object.assign({}, ...dictlist);
        dict["identifier"] = { id: dict["id"], url: dict["url"], type: "doi" };
        delete dict.id;
        delete dict.url;

        this.doiState = dict;
        /* var dict = Object.assign({}, ...dataa);
        dict["identifier"] = { id: dict["DOI"], url: dict["URL"], type: "doi" };
        delete dict.DOI;
        delete dict.URL;
        this.doiState = dict */
        this.setIsLoading(false);
        this.setLoadingMessage("");
        this.openDialog();
      } catch {
        this.setIsLoading(false);
        this.setLoadingMessage("");
        alert("error DOI");
      }
    },
  },
};
</script>

<style>
</style>